<template>
  <el-dialog
    title=""
    :visible.sync="cashShow"
    :width="cashType?.type_id == 1 ? '400px' : '360px'"
    :before-close="handleClose"
    :append-to-body="true"
    class="cashDialog"
    :close-on-click-modal="false"
  >
    <div class="content">
      <div class="boxx">
        <img
          ref="cashImgRef"
          @load="handleImageLoad"
          :style="{ width: cashType?.type_id == 1 ? '400px' : '360px' }"
          :src="cashType?.web_popup_img"
          alt=""
        />
        <div v-if="cashType?.type_id == 1">
          <div class="type_id1">
            <div
              class="type_idtitle"
              v-for="(item, index) in cashType?.coupon_list"
              :key="index"
            >
              <div class="title">{{ item.title }}</div>
              <div class="label">{{ item.label }}</div>
            </div>
          </div>

          <div class="vip_benefits-box">
            <div
              class="vip_benefits"
              v-for="(item, index) in cashType?.vip_benefits"
              :key="index"
            >
              <img class="icon" :src="item.icon" />
              <div class="spec_label">{{ item.web_title }}</div>
              <div class="label">{{ item.web_label }}</div>
            </div>
          </div>
        </div>
        <div v-if="cashType?.type_id == 2">
          <div class="type_id12">
            <div
              class="type_idtitle"
              v-for="(item, index) in cashType?.coupon_list"
              :key="index"
            >
              <div class="title">{{ item.title }}</div>
              <div class="label">{{ item.label }}</div>
            </div>
          </div>
        </div>
      </div>
      <fm-button class="cashButton" @click="confirm" round size="medium">{{
        buttonText
      }}</fm-button>

      <div class="btn-svg">
        <svg-btn
          style="width: 14; cursor: pointer"
          @click="checkArchives"
          :icon-class="isChecked ? 'icon-file-check' : 'icon-file-uncheck2'"
        >
        </svg-btn>
        <span class="sspan">今日不再弹出</span>
      </div>
      <svg-btn
        @click="handleClose"
        :class="height < 340 ? 'close-icon' : 'close-icon2'"
        icon-class="icon-cash-close"
      />
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    cashShow: {
      type: Boolean,
      default: false,
    },
    cashType: {
      type: Object,
      default: {},
    },
    cashImg: {
      type: String,
      default: "",
    },
    buttonText: {
      type: String,
      default: "立即收下",
    },
  },
  data() {
    return {
      height: 0,
      isChecked: false,
    };
  },
  created() {},
  methods: {
    //勾选协议
    checkArchives() {
      this.isChecked = !this.isChecked;
    },
    handleImageLoad() {
      const img = this.$refs.cashImgRef;
      if (img) {
        this.height = img.clientHeight; // 获取实际渲染高度
      }
    },
    confirm() {
      this.$emit("confirm", this.isChecked);
    },
    handleClose() {
      this.$emit("handleClose", this.isChecked);
    },
  },
};
</script>

<style lang="scss" scoped>
.cashDialog {
  ::v-deep .el-dialog {
    box-shadow: none !important;
    background: transparent !important;
  }
  ::v-deep .el-dialog__body {
    padding: 0 !important;
  }
  .content {
    position: relative;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;

    .boxx {
      position: relative;

      .type_id1 {
        position: absolute;
        top: 144px;
        right: 74px;
        width: 156px;
        // background: #fe4162;

        .type_idtitle {
          .title {
            line-height: 22px;
            font-weight: 500;
            font-size: 14px;
            color: #ffffff;
          }
          .label {
            line-height: 22px;
            font-weight: 400;
            font-size: 10px;
            color: #ffffff;
            line-height: 12px;
            overflow: hidden; //超出的文本隐藏
            text-overflow: ellipsis; //溢出用省略号显示
            white-space: nowrap; // 默认不换行；
          }
        }
      }

      .type_id12 {
        position: absolute;
        top: 108px;
        right: 54px;
        width: 156px;
        // background: #fe4162;

        .type_idtitle {
          margin-bottom: 42px;
          .title {
            line-height: 22px;
            font-weight: 500;
            font-size: 14px;
            color: #ffffff;
          }
          .label {
            line-height: 22px;
            font-weight: 400;
            font-size: 10px;
            color: #ffffff;
            line-height: 12px;
            overflow: hidden; //超出的文本隐藏
            text-overflow: ellipsis; //溢出用省略号显示
            white-space: nowrap; // 默认不换行；
          }
        }
      }

      .vip_benefits-box {
        position: absolute;
        bottom: 22px;
        display: flex;
        justify-content: center;
        width: 100%;

        .vip_benefits {
          text-align: center;
          display: inline-block;
          min-width: 68px;
          margin: 0 2.5px;
          .icon {
            width: 32px;
            height: 32px;
            margin-bottom: 4px;
          }

          .spec_label {
            font-weight: 400;
            font-size: 12px;
            color: #845127;
            line-height: 17px;
          }

          .label {
            font-weight: 400;
            font-size: 10px;
            color: #845127;
            line-height: 14px;
            opacity: 0.7;
          }
        }
      }
    }

    .btn-svg {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      position: absolute;
      left: 50%;
      bottom: -116px;
      transform: translate(-50%, -50%);

      .sspan {
        margin-left: 8px;
        line-height: 20px;
        height: 20px;
        font-size: 12px;
        color: #ffffff;
        -webkit-user-select: none; /* Chrome/Safari */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* IE10+ */
        user-select: none; /* 标准语法 */
      }
    }
    .cashButton {
      background: linear-gradient(137deg, #fd513a 0%, #fe4162 100%);
      position: absolute;
      left: 50%;
      bottom: -97px;
      transform: translate(-50%, -50%);
      width: 168px;
      height: 48px;
      border-radius: 24px;
      font-weight: 600;
      font-size: 18px;
      color: #ffffff;
      line-height: 28px;
    }
    .close-icon {
      width: 28px;
      height: 28px;
      position: absolute;
      right: -28px;
      top: -28px;
      cursor: pointer;
    }
    .close-icon2 {
      width: 28px;
      height: 28px;
      position: absolute;
      right: -18px;
      top: -6px;
      cursor: pointer;
    }
  }
}
</style>
